import { StudentWizard } from "../../../components/Wizard/Student";

export const WizardStudentPage = () => {
  return <StudentWizard />;
};
